import store from "@/store";
const base = "//oss.halobear.com/fonts/";
const addMap = {};

// 动态引入css
export function appendCss(href) {
  if (!href) return;
  const link = document.createElement("link");
  link.href = href;
  link.rel = "stylesheet";
  document.head.appendChild(link);
}

// 整个引入字体文件
// 添加样式
export function addFonts(fileName = "") {
  const family = fileName.split(".")[0] || "";
  if (addMap[family] && !family) return;

  addMap[family] = 1;
  const _s = document.createElement("style");
  _s.innerHTML = `@font-face {
  font-family: ${family};
  src: url('${base}${family}.ttf');
  font-style: normal;
  font-weight: normal;
}`;
  document.head.append(_s);
}

// 格式化样式
export function styleFormat(style = {}) {
  const {
    scaleX = 1,
    scaleY = 1,
    rotate = 0,
    translateX = 0,
    translateY = 0,
    skewX = 0,
    skewY = 0
  } = style;
  if (
    scaleX === 1 &&
    scaleY &&
    !rotate &&
    !translateX &&
    !translateY &&
    !skewX &&
    !skewY
  ) {
    return "none";
  }
  return `translate(${translateX},${translateY}) scale(${scaleX}, ${scaleY}) rotate(${rotate}deg) skew(${skewX}deg, ${skewY}deg)`;
}

// 尺寸转换
export function xValue(x) {
  if (!x) return 0;
  const { width } = store.state.config;
  return Math.round((parseFloat(x) / 100) * width);
}
export function yValue(y) {
  if (!y) return 0;
  const { height } = store.state.config;
  return Math.round((parseFloat(y) / 100) * height);
}
export function xPercent(x) {
  if (!x) return 0;
  const { decimal, width } = store.state.config;
  return `${((x / width) * 100).toFixed(decimal)}%`;
}
export function yPercent(y) {
  if (!y) return 0;
  const { decimal, height } = store.state.config;
  return `${((y / height) * 100).toFixed(decimal)}%`;
}
